import { Observable } from 'rxjs';
import { DataSourceResponse, SmsSetting } from '../../models';
import { Injectable } from '@angular/core';
import { ApiService } from '@meddatacore/common';
import { HttpParamsEncoder } from '../../tools';

@Injectable({ providedIn: 'root' })
export class SmsSettingService extends ApiService {
    endPoint = '/api/sms-setting';
    create(model: SmsSetting) {
        return this.http.post(`${this.notificationBaseUrl}${this.endPoint}`, model);
    }

    update(model: SmsSetting) {
        return this.http.put(`${this.notificationBaseUrl}${this.endPoint}`, model);
    }

    delete(id: string) {
        return this.http.delete<any>(`${this.notificationBaseUrl}${this.endPoint}/${id}`);
    }

    get(id: string): Observable<SmsSetting> {
        return this.http.get<SmsSetting>(`${this.notificationBaseUrl}${this.endPoint}/${id}`);
    }

    getList(queryParams: any): Observable<DataSourceResponse<SmsSetting>> {
        const params = new HttpParamsEncoder().encode(queryParams);
        return this.http.get<any>(`${this.notificationBaseUrl}${this.endPoint}`, { params });
    }
}
